import React, { useRef } from 'react';
import { useOption } from 'react-aria';

import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';
import styles from './InsightAddListBoxOption.module.css';

import { Circle } from '../../../components/common/Circle';
import { Glyph } from '../../../components/common/Glyph';
import { TextSmall } from '../../../components/common/text/TextSmall';

export function InsightAddListBoxOption(props) {
  const optionRef = useRef();
  const color = props.colorMap[props.item.key];

  const isDisabled = props.listState.disabledKeys.has(props.item.key);
  const isSelected = props.listState.selectionManager.isSelected(props.item.key);

  const option = useOption(
    {
      key: props.item.key,
      isDisabled,
      isSelected,
    },
    props.listState,
    optionRef,
  );

  return (
    <li {...option.optionProps} ref={optionRef} className={styles.root}>
      <div className={styles.checkbox} data-is-selected={isSelected || undefined}>
        <Glyph
          size={theme.icon.size_small}
          source={glyph.core.checkmark}
          color={isSelected ? theme.color.white : 'transparent'}
        />
      </div>

      <div>
        <div className={styles.uriDetails}>
          <small>
            <strong>{props.ownerName}</strong>&nbsp;
            <span className={styles.zoneName}>{props.ownerZoneName}</span>
          </small>
        </div>

        <div className={styles.logDetails}>
          <Circle hue={color?.hue ?? 0} />
          <TextSmall>{props.item.value.title}</TextSmall>
        </div>
      </div>
    </li>
  );
}
